export interface InclusionItem {
  text: string;
  icon?: string;
  description?: string;
}

export type InclusionField = string[] | InclusionItem[] | undefined;

export const normalizeInclusion = (v: string | InclusionItem): InclusionItem =>
  typeof v === 'string' ? { text: v } : v;

export const normalizeInclusionList = (list: InclusionField): InclusionItem[] =>
  (list ?? []).map(normalizeInclusion);

export const isStructuredInclusion = (v: unknown): v is InclusionItem =>
  typeof v === 'object' && v !== null && 'text' in v;

/**
 * Convert an inclusion list to the persisted shape. Strips empty items and
 * defaults to plain strings so deployed customer apps keep receiving the
 * legacy marketplace contract while desktop updates roll out.
 */
export const serializeInclusions = (items: InclusionItem[]): string[] | InclusionItem[] => {
  const cleaned = items
    .map((it) => ({ ...it, text: it.text?.trim() ?? '' }))
    .filter((it) => it.text.length > 0);
  if (process.env.REACT_APP_MARKETPLACE_RICH_INCLUSIONS !== 'true') {
    return cleaned.map((it) => it.text);
  }
  const anyRich = cleaned.some((it) => it.icon || it.description);
  if (!anyRich) return cleaned.map((it) => it.text);
  return cleaned.map((it) => {
    const out: InclusionItem = { text: it.text };
    if (it.icon) out.icon = it.icon;
    if (it.description?.trim()) out.description = it.description.trim();
    return out;
  });
};
